'use client'

import { Suspense } from 'react'
import dynamic from 'next/dynamic'
import { MacbookScroll } from '@dom/MacbookScroll'
import { HeadHome } from '@dom/HeadHome'
import LoadingFallback from '@/client/components/dom/LoadingFallback'

export const runtime = 'edge'

const DynamicOceanExperience = dynamic(() => import('@metaverso/OceanExperience'), {
  ssr: false
})

const Page = () => {
  return (
    <MacbookScroll title={<HeadHome />} showGradient={true}>
      <Suspense fallback={<LoadingFallback />}>
        <DynamicOceanExperience />
      </Suspense>
    </MacbookScroll>
  )
}

Page.displayName = 'Inicio'
export default Page
